<template>
  <div
    class="flex justify-between items-start bg-bkk-50 rounded-xl p-4 w-full h-[250px] mt-8"
  >
    <div class="flex flex-col gap-4 justify-between h-full">
      <h3 class="max-w-52 sm:max-w-96 md:max-w-4xl text-large line-clamp-3">
        {{ title }}
      </h3>

      <div>
        <div class="flex items-center gap-2">
          <div class="bg-white rounded-full p-1"><StartDateIcon /></div>

          <span>{{ dayjs(startDate).format("DD.MM.YYYY") }}</span>
        </div>

        <div class="flex items-center gap-2 pt-1">
          <div class="bg-white rounded-full p-1"><IntervalIcon /></div>
          <span> {{ $t("challenge.preview.daily") }}</span>
        </div>

        <div class="flex items-center gap-2 pt-1">
          <div class="bg-white rounded-full p-1"><EndDateIcon /></div>
          <span>{{ dayjs(endDate).format("DD.MM.YYYY") }}</span>
        </div>
      </div>
    </div>

    <div class="relative">
      <img
        :src="imageSrc"
        alt=""
        class="h-[218px] object-cover rounded-lg max-w-80"
      />
      <div class="absolute top-2 right-2 bg-white rounded-full p-2">
        <span
          v-if="
            activityType ===
              ActivityType.CUSTOM_CHALLENGE_ACTIVITY_TYPE_BICYCLE ||
            compType === ActivityType.COMPETITIVE_CHALLENGE_TYPE_BICYCLE
          "
          ><BikeIcon />
        </span>
        <span
          v-else-if="
            activityType ===
              ActivityType.CUSTOM_CHALLENGE_ACTIVITY_TYPE_STEPS ||
            compType === ActivityType.COMPETITIVE_CHALLENGE_TYPE_STEPS
          "
          ><WalkIcon />
        </span>
        <span v-else><MoreDotIcon /></span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import dayjs from "dayjs";
import StartDateIcon from "../icon/StartDateIcon.vue";
import IntervalIcon from "../icon/IntervalIcon.vue";
import EndDateIcon from "../icon/EndDateIcon.vue";
import defaultImage from "../../../assets/images/default.jpg";
import WalkIcon from "../icon/WalkIcon.vue";
import { ActivityType } from "../../../enum/v2/activityType.ts";
import MoreDotIcon from "../icon/MoreDotIcon.vue";
import BikeIcon from "../icon/BikeIcon.vue";

const props = defineProps({
  startDate: {
    type: String,
    required: true,
  },
  endDate: {
    type: String,
    required: true,
  },
  image: {
    type: String,
  },
  title: {
    type: String,
  },
});

const imageSrc = computed(() => props.image || defaultImage);
</script>
